<template>
  <div class="toggle-block" :class="active">
    <div class="toggle-block__before" v-show="$slots.before">
      <slot name="before"></slot>
    </div>

    <div class="toggle-block__inner">
      <input v-if="disabled" type="checkbox" class="cbx" :id="id" style="display:none" v-model="on" disabled/>
      <input v-else type="checkbox" class="cbx" :id="id" style="display:none" v-model="on" />
      <label :for="id" class="toggle" :class="value ? 'toggle--active' : null">
        <span></span>
      </label>
    </div>

    <div class="toggle-block__after" v-show="$slots.after">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    active () {
      return this.on ? 'toggle-block--active' : null
    },

    on: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>

<style lang="scss">
  .toggle-block {
    display: flex;
    align-items: center;
    font-size: 1.2rem;

    &__before {
      margin-right: 1.2rem;
    }

    &__after {
      margin-left: 1.2rem;
      opacity: 1;
    }

    &--active {
      .toggle-block__before {
        opacity: 1;
      }

      .toggle-block__after {
        color: $color-secondary;
        opacity: 1;
      }
    }
  }

  .toggle {
    position: relative;
    display: block;
    width: 4.4rem;
    height: 2rem;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transform: translate3d(0,0,0);

    &:before {
      content: "";
      position: relative;
      top: .2rem;
      left: .3rem;
      width: 4rem;
      height: 1.67rem;
      display: block;
      background: $color-grey-dark;
      border-radius: 1rem;
      transition: background .2s ease;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      width: 2rem;
      height: 2rem;
      display: block;
      background: white;
      border-radius: 50%;
      box-shadow: 0 3px 8px rgba($color-grey-dark,.5);
      transition: all .2s ease;

      &:before {
        content: "";
        position: absolute;
        display: block;
        margin: -2rem;
        width: 6rem;
        height: 6rem;
        background: rgba($color-primary,.5);
        border-radius: 50%;
        transform: scale(0);
        opacity: 1;
        pointer-events: none;
      }
    }
  }
  //.cbx:checked + .toggle--active {
  .toggle--active {
    &:before {
      background: lighten($color: $color-primary, $amount: 40%);
    }

    span {
      background: $color-primary;
      transform: translateX(3rem);
      transition: all .2s cubic-bezier(.8,.4,.3,1.25), background(.15s ease);
      box-shadow: 0 3px 8px rgba($color-primary,.2);

      &:before {
        transform: scale(1);
        opacity: 0;
        transition: all .4s ease;
      }
    }
  }
</style>
